import { ReactLenis } from "lenis/react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { PadsSection } from "@/components/PadsSection";
import { RotorsSection } from "@/components/RotorsSection";
import { Ethos } from "@/components/Ethos";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="grain-overlay" />
      <div data-testid="landing-page" className="relative bg-black min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <PadsSection />
          <RotorsSection />
          <Ethos />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
